export default {"src":"/_next/static/media/Sensors.c78c4133.svg","height":30,"width":29};